import { useContext } from "react";
import { PlaybackContextType } from "../../types/playback-provider";
import { ConferencePlaybackContext } from "../../components/ConferencePlaybackProvider/ConferencePlaybackProvider";

export const useConferencePlaybackContext = (): PlaybackContextType => {
	const context = useContext(ConferencePlaybackContext);
	if (!context) {
		throw new Error("useConferencePlaybackContext must be used within a ConferencePlaybackProvider");
	}
	return context;
}
